import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { IDarkTheme } from "styles/darkTheme";

const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    signInContainer: {
      background: `linear-gradient(223.4deg, ${theme.colors.secondary.secondary_40} 24.3%, ${theme.colors.secondary.secondary_50} 94.86%);`,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      position: "relative",
      overflow: "hidden"
    },
    leftGrid: {
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      margin: "0 auto"
    },
    carouselMidBtn: {
      color: theme.colors.semantic.semantic_white,
      opacity: "60%",
      "&:focus": {
        opacity: "80%"
      },
      "&:focus + button": {
        opacity: "60%"
      }
    },
    carouselBtn: {
      color: theme.colors.semantic.semantic_white,
      opacity: "40%",
      "&:focus": {
        opacity: "80%"
      },
      "&:focus + button": {
        opacity: "60%"
      }
    },
    logo: {
      position: "absolute",
      left: "100px",
      top: "40px"
    },
    rightGrid: {
      height: "100vh",
      background: theme.colors.semantic.semantic_white,
      zIndex: "20"
    },
    tutorialImage: {
      height: "638px",
      width: "869px",
      maxHeight: "100vh",

      marginTop: "55px",
      position: "relative",
      display: "none",
      "@media (max-width: 420px)": {
        width: "90%",
        marginTop: "0px"
      }
    },
    firstImage: {
      padding: "1.563rem 0rem 4.688rem 5.313rem"
    },
    fadeInImage: {
      display: "block",
      animation: "$fadeIn 3s"
    },
    "@keyframes fadeIn": {
      "0%": { opacity: 0 },
      "100%": { opacity: 1 }
    },

    card: {
      padding: "32px",
      borderRadius: "8px",
      boxShadow: "0px 1px 32px rgba(0, 0, 0, 0.05)",
      width: "398px",
      marginTop: "12px",
      "@media (max-width: 420px)": {
        width: "90%",
        padding: "25px"
      }
    },
    signInCard: {
      display: "flex",
      flexDirection: "column",
      justifyItems: "center",
      alignItems: "center",
      padding: "0"
    },
    slackUrl: {
      textTransform: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "bold",
      color: theme.colors.neutrals.neutrals_80,
      width: "100%",
      padding: "20px",
      borderRadius: "8px",
      border: `solid 2px ${theme.colors.neutrals.neutrals_80}`
    },
    slackIcon: {
      width: "20px",
      height: "20px",
      marginRight: "8px"
    },
    orText: {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: 400,
      color: theme.colors.neutrals.neutrals_70,
      margin: "16px 0"
    },
    signTxt: {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: 400,
      color: theme.colors.neutrals.neutrals_70,
      margin: "24px 0 32px 0"
    },
    termsAndConditions: {
      marginTop: "12px",
      fontWeight: 400,
      color: theme.colors.semantic.semantic_grey,
      fontSize: "12px",
      lineHeight: "16px",
      textAlign: "center",
      "@media (max-width: 420px)": {
        width: "90%"
      }
    },
    link: {
      color: theme.colors.semantic.semantic_grey,
      textDecoration: "underline",
      cursor: "pointer"
    },
    loginLogo: {
      width: "170px",
      height: "50px",
      marginRight: "8px"
    },
    title: {
      fontSize: "20px",
      textAlign: "center",
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "#1C0C2E"
    },
    loadMoreBtnWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    loadMoreButton: {
      width: "146px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "2px solid #ca5335",
      borderRadius: "6px",
      margin: "16px 0",
      padding: 0
    },
    loadMoreBtnLabel: {
      fontFamily: "Lato",
      fontSize: "16px",
      fontWeight: "bold",
      letterSpacing: "normal",
      color: "#ca5335",
      textTransform: "none"
    },
    header: {
      width: "65%"
    }
  })
);

export default styles;
